import { isAuthRoutePath } from "@/lib/auth/is-auth-route";

const DEFAULT_POSTHOG_HOST = "https://eu.i.posthog.com";

/** Custom ingestion hosts known to be misconfigured (DNS) — use PostHog cloud until fixed. */
const DEPRECATED_POSTHOG_HOSTS = new Set([
  "https://t.menuhunter.app",
  "http://t.menuhunter.app",
  "t.menuhunter.app",
]);

/** PostHog ingestion host with fallback when custom DNS (e.g. t.menuhunter.app) is broken. */
export function resolvePostHogHost(): string | undefined {
  const raw = process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim();
  if (!raw) return DEFAULT_POSTHOG_HOST;
  const normalized = raw.replace(/\/$/, "");
  if (DEPRECATED_POSTHOG_HOSTS.has(normalized)) {
    return DEFAULT_POSTHOG_HOST;
  }
  return normalized;
}

export function shouldInitializePostHogClient(pathname: string): boolean {
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim()) return false;
  return !isAuthRoutePath(pathname);
}

export function getPostHogClientInitOptions() {
  const isLocalDev =
    typeof process !== 'undefined' &&
    (process.env.NODE_ENV === 'development' || process.env.VERCEL_ENV === 'development');

  return {
    api_host: resolvePostHogHost(),
    defaults: "2026-01-30" as const,
    capture_pageview: true,
    capture_pageleave: true,
    /** Client-side exception autocapture (web only). Server errors use instrumentation.ts. */
    capture_exceptions: !isLocalDev,
    loaded: (posthog: { register: (props: Record<string, string>) => void }) => {
      const build = process.env.NEXT_PUBLIC_APP_BUILD?.trim();
      const version = process.env.NEXT_PUBLIC_APP_VERSION?.trim();
      const props: Record<string, string> = { source: 'web' };
      if (build) props.app_build = build;
      if (version) props.app_version = version;
      if (process.env.VERCEL_ENV) props.app_env = process.env.VERCEL_ENV;
      posthog.register(props);
    },
  };
}
